import { useTranslation } from 'react-i18next';
import { StackView, Box, Typography, Icon, Spacer } from '@telus-uds/components-web';
import { Firewall, Refresh, Settings } from '@telus-uds/palette-allium/build/web/icons';
import { LockFilled, Refresh as KoodoRefresh, Settings as KoodoSettings } from '@telus-uds/palette-koodo/build/web/icons';
import { useTheme } from '../../BrandThemeProvider';

const brandIcons = {
  TELUS: {
    security: Firewall,
    savings: Refresh,
    ease: Settings
  },
  Koodo: {
    security: LockFilled,
    savings: KoodoRefresh,
    ease: KoodoSettings
  }
};

const brandIconVariants = {
  TELUS: { color: 'brand' },
  Koodo: { color: 'black' },
};

export const ReasonsToTrust = () => {
  const { t } = useTranslation();
  const { currentBrand } = useTheme();

  const reasons = [
    {
      icon: brandIcons[currentBrand]?.security || brandIcons.TELUS.security,
      title: t('reasons.security'),
    },
    {
      icon: brandIcons[currentBrand]?.savings || brandIcons.TELUS.savings,
      title: t('reasons.savings'),
    },
    {
      icon: brandIcons[currentBrand]?.ease || brandIcons.TELUS.ease,
      title: t('reasons.ease'),
    },
  ];

  const iconColor = brandIconVariants[currentBrand]?.color || brandIconVariants.Default.color;

  return (
    <Box flex={1} top={{ xs: 7, md: 8 }} bottom={2}>
      <Typography tag="h2" variant={{ size: 'h2' }}>
        {t('reasons.title')}
      </Typography>
      <Spacer space={4} />
      <StackView direction={{ xs: 'column', md: 'row' }} space={4} tokens={{ justifyContent: 'space-between' }}>
        {reasons.map((reason, index) => (
          <StackView key={index} direction="row" space={3} tokens={{ alignItems: 'center' }}>
            <Icon icon={reason.icon} variant={{ color: iconColor, size: 'large' }} />
            <Typography tag="p" variant={{ size: 'medium' }}>
              {reason.title}
            </Typography>
          </StackView>
        ))}
      </StackView>
    </Box>
  );
};
